import "./App.css";
import { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

function App() {
  const [menuVisible, setMenuVisible] = useState(false);
  const [sesion, setSesion] = useState(false)
  const navigate = useNavigate();

  
  const showMenu = () => {
    setMenuVisible(!menuVisible); // Cambiar el estado de visibilidad
  };


  //verificar sesion
   useEffect(() => {
    fetch("https://disomex.onrender.com/api/verificar-sesion", {
      method: "GET",
      credentials: "include", // 🔥 Esto es clave para que las cookies se envíen en la petición
    })
      .then(response => response.json())
      .then(data => {
        if (data.valid) {
          console.log("✅ Usuario autenticado:", data.usuario);
          setSesion(true)
        } else {
          console.log("⛔ Token inválido o expirado.");
          setSesion(false)
        }
      })
      .catch(error => {
        setSesion(false)
        console.error("❌ Error al obtener la sesión:", error);
      });
  }, []);

 
  const cerrarSesion = async () => {
    try {
      setSesion(false);
  
      const response = await fetch("https://disomex.onrender.com/api/logout", {
        method: "POST",
        credentials: "include", // Incluye las cookies en la solicitud
      });
      const data = await response.json();
      console.log(data.message);
  
      // Eliminar la cookie 'authToken' desde el frontend
      document.cookie = "authToken=; path=/; domain=disomex.com.mx; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure; sameSite=None";
  
      // Redirigir al usuario a la página de login sin recargar la página
      navigate("/login");
    } catch (error) {
      console.error("⛔ Error al cerrar sesión:", error);
    }
  };
  

  return (
    <div className="mb-[84px]">
      <div className="bg-[#04141f] flex justify-between fixed top-0 left-0 z-10 items-center p-4 w-full mb-10">
        <img className="w-[150px]" src="assets/Diseño_DD.png" alt="Diseño" />

        <div className="sm:hidden" onClick={showMenu}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </div>

        <ul className="hidden flex space-x-6 items-center sm:inline-flex">
          <li>
            <Link to="/" className="text-xl text-white hover:text-2xl transition-all duration-300 ease-in-out  hover:text-[#e9aa0d] ">
              Inicio
            </Link>
          </li>
        
          {sesion === false ? (
            <li> <Link to="/servicios" className=" text-xl text-white  hover:text-2xl transition-all duration-300 ease-in-out hover:text-[#e9aa0d] ">
              Servicios
            </Link></li>): <li> <Link to="/servicios-admin" className=" text-xl text-white  hover:text-2xl transition-all duration-300 ease-in-out hover:text-[#e9aa0d] ">
              Servicios
            </Link></li>
            }

            <li>
  {sesion === false ? (
    <Link
      to="/login"
      className="text-xl text-white hover:text-2xl transition-all duration-300 ease-in-out hover:text-[#e9aa0d]"
    >
      Login
    </Link>
  ) :   <button
  onClick={cerrarSesion}
  className="text-xl text-white hover:text-2xl transition-all duration-300 ease-in-out hover:text-[#e9aa0d]"
>
  Cerrar Sesion
</button>}
</li>

        </ul>
        
      </div>

      <ul
        id="menu"
        className={`flex bg-[#04141f] h-screen w-full fixed top-[87px] left-0 z-50 flex-col space-y-6 items-center   sm:hidden ${
          menuVisible ? "block" : "hidden"
        }`}
      >
        <li><Link to="/" className="text-3xl mt-24 text-white"  onClick={() => setMenuVisible(false)}>Inicio </Link></li>
        {sesion === false ? (
            <li> <Link to="/servicios" className=" text-3xl text-white  hover:text-2xl transition-all duration-300 ease-in-out hover:text-[#e9aa0d] " onClick={() => setMenuVisible(false)}>
              Servicios
            </Link></li>): <li> <Link to="/servicios-admin" className=" text-3xl text-white  hover:text-2xl transition-all duration-300 ease-in-out hover:text-[#e9aa0d] " onClick={() => setMenuVisible(false)}>
              Servicios
            </Link></li>
            }
       {sesion === false ? (
    <Link
      to="/login"
      className="text-3xl text-white hover:text-2xl transition-all duration-300 ease-in-out hover:text-[#e9aa0d]"
      onClick={() => setMenuVisible(false)} >
      Login
    </Link>
  ) :   <button
  onClick={cerrarSesion}
  className="text-3xl text-white hover:text-2xl transition-all duration-300 ease-in-out hover:text-[#e9aa0d]" 
>
  Cerrar Sesion
</button>}

      </ul>
    </div>
  );
}

export default App;
